import { defineComponent, h } from '@vue/composition-api';
import { Position } from '../../types';

interface Props {
  position: Position;
  centerX: number;
  centerY: number;
  radius?: number;
  type: string;
}

function shiftX(x: number, shift: number, position: Position): number {
  if (position === Position.Left) {
    return x - shift;
  }
  if (position === Position.Right) {
    return x + shift;
  }
  return x;
}

function shiftY(y: number, shift: number, position: Position): number {
  if (position === Position.Top) {
    return y - shift;
  }
  if (position === Position.Bottom) {
    return y + shift;
  }
  return y;
}

const EdgeAnchor = defineComponent<Props>({
  name: 'EdgeAnchor',
  props: {
    radius: { type: Number, default: 10 },
    centerX: { type: Number, default: 0 },
    centerY: { type: Number, default: 0 },
    position: { type: String, default: Position.Top }
  },
  setup(props) {
    return () =>
      h('circle', {
        class: `workflow__edgeupdater workflow__edgeupdater-${props.type}`,
        attrs: {
          cx: shiftX(props.centerX, props.radius!, props.position),
          cy: shiftY(props.centerY, props.radius!, props.position),
          r: props.radius,
          stroke: 'transparent',
          fill: 'transparent'
        }
      });
  }
});

export default EdgeAnchor;
